const $win = $(window);

$('.nav a').on('click', function(e) {
  const $this = $(this);

  if ($this.siblings('.nav__dropdown').length) {
    if($win.width() < 1024) {
      e.preventDefault();

      $this
        .next()
        .slideToggle()
        .parent()
        .toggleClass('expanded')
        .siblings()
        .removeClass('expanded')
        .find('.nav__dropdown')
        .slideUp();
    }
  }
});

// Clone Section To Mobile Navigation
const $section = $('.js-section-nav-mobile');

if ($section.length) {
  $section
    .clone()
    .addClass('section-fixed--alt')
    .removeAttr('id')
    .insertAfter('.header .header__mobile .nav');
};



// WEBPACK FOOTER //
// ../assets/js/mobile-navigation.js